enum ConfidenceLevels {
    High = "High",
    Low = "Low",
    Unset = "Unset",
    Definite = "Definite",
    Probable = "Probable",
    Unsure = "Unsure",
}

export default ConfidenceLevels